import type { Site } from '../Site';

export const ThePrivacyLab: Site = {
  id: 'theprivacylab',
  analyticsName: 'theprivacylab',
  selector: '',
  logo: '',
  label: 'The Privacy Lab',
  platform: '',
};
